import { render } from "./Personal.vue?vue&type=template&id=0f141cb2&ts=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__